import { z } from "zod";
import { EServiceCategory, EServiceType } from "./common";
import { userBasicPublicInfoSchema } from "./user";
import { partnerResponseDtoSchema } from "./partner";
import { AdminTaskResponseDto } from "./task";

export const incompleteSessionTaskDataSchema = z.object({
    partner: partnerResponseDtoSchema.nullish(),
    user: userBasicPublicInfoSchema.nullish(),
    scheduledAt: z.number(),
    startedAt: z.number().nullish(),
    endedAt: z.number().nullish(),
    serviceCategory: z.nativeEnum(EServiceCategory),
    serviceType: z.nativeEnum(EServiceType),
    createdAt: z.number(),
    city: z.string(),
    status: z.string(),
    duration: z.number(),
});

export type IncompleteSessionTaskResponseDto = z.infer<typeof incompleteSessionTaskDataSchema>;

export type IIncompleteSession = AdminTaskResponseDto<IncompleteSessionTaskResponseDto>;

